import * as React from 'react';
import useMe from 'src/components/AuthContext/useMe';
import cn from 'src/lib/cn';
import { formatDate, formatDayCalendar, today } from 'src/lib/date';

interface IProps {
  date: Date;
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  bookings?: Odoo.Booking[];
}

const WeekDay: React.FC<IProps> = ({ date, active, disabled, onClick, bookings }) => {
  const meId = useMe()?.id;
  const todayDate = today();
  const isToday = formatDate(todayDate) === formatDate(date);
  const myBooking = bookings?.find(b => b.organizer_id[0] === meId);

  return (
    <div
      className={cn('calendar-day', { 'calendar-day--disabled': disabled, 'calendar-day--active': active })}
      onClick={onClick}
    >
      <div className="calendar-day__header">
        <div className="calendar-day__date">
          {isToday && <span className="calendar-day__today-ring" />}
          {formatDayCalendar(date)}
        </div>
      </div>
      <ul className="calendar-day__bookings">
        {myBooking && <li className="calendar-day__booking calendar-day__booking--my">Booked</li>}
      </ul>
    </div>
  );
};

export default WeekDay;
